import { render, staticRenderFns } from "./LinkParentModal.vue?vue&type=template&id=96907c28&"
import script from "./LinkParentModal.vue?vue&type=script&lang=js&"
export * from "./LinkParentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports